export { renderers } from './canvas'



// WEBPACK FOOTER //
// ./src/drawing/renderers/index.js